import { render } from "./BiotronDeviceSelector.vue?vue&type=template&id=238e3228&scoped=true"
import script from "./BiotronDeviceSelector.vue?vue&type=script&lang=js"
export * from "./BiotronDeviceSelector.vue?vue&type=script&lang=js"

import "./BiotronDeviceSelector.vue?vue&type=style&index=0&id=238e3228&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238e3228"]])

export default __exports__